module.exports = __webpack_public_path__ + "static/media/one.19fefc51.png";